import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Error aate hi state badal do taaki fallback UI dikhe
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Yahan hum error ko console mein ya database mein bhej sakte hain
    console.error("🚨 WEBSITE CRASHED:", error, errorInfo);
    
    // Future mein yahan Sentry ya Email API laga sakte ho
    // sendErrorToMyEmail(error); 
  }

  render() {
    if (this.state.hasError) {
      // ✅ Agar error aaya toh ye dikhega (Poori site gayab nahi hogi)
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 p-6 text-center">
          <div className="text-6xl mb-4">🤕</div>
          <h1 className="text-3xl font-bold text-slate-800 mb-2">Oops! Kuch gadbad ho gayi.</h1>
          <p className="text-slate-500 mb-6">Chinta mat karein, humari team ko pata chal gaya hai.</p>
          
          <button 
            onClick={() => window.location.reload()} 
            className="bg-blue-600 text-white px-6 py-3 rounded-xl font-bold shadow-lg hover:bg-blue-700 transition"
          >
            🔄 Refresh Page
          </button>
          
          <div className="mt-8 p-4 bg-red-50 text-red-800 text-xs rounded-lg border border-red-100 max-w-md break-all">
             Tip: Agar baar-baar ho raha hai, toh cache clear karein.
          </div>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;